import React from "react";
import { Button } from "@truevault/aquilo";
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";

export interface CardProps {
  title?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  description?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  externalLinkIcon?: boolean;
  variant?: "default" | "warning";
  dropShadow?: boolean;
}

const Card = ({
  title,
  buttonText,
  onButtonClick,
  description,
  icon,
  children,
  dropShadow = false,
  externalLinkIcon = false,
  variant = "default",
}: CardProps) => {
  return (
    <div
      className={`tw-boundary flex flex-col justify-between p-6 w-[448px] rounded-lg mt-3 ${
        variant === "warning" ? "bg-amber-100 w-auto" : ""
      } ${
        dropShadow
          ? "shadow-[0px_2px_12px_0px_#00000033]"
          : variant === "warning"
          ? "border-[1.5px] border-amber-300 hover:border-amber-400"
          : "border-[1.5px] border-neutral-400 hover:border-primary-600"
      }`}
    >
      {title && (
        <div className="flex justify-between items-start">
          <div className="flex items-center">
            {icon && <div style={{ flexShrink: 0 }}>{icon}</div>}
            {title && (
              <div className={`text-gray-500 font-bold text-lg leading-5 ${icon ? "ml-3" : ""}`}>
                {title}
              </div>
            )}
          </div>
          {externalLinkIcon && <ArrowUpRightIcon className="w-5 h-5 text-neutral-400" />}
        </div>
      )}
      {description && <div className="text-gray-500 text-sm font-normal my-3">{description}</div>}
      {children}
      {buttonText && onButtonClick && (
        <Button size="m" color="tertiary" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default Card;
